export default {
    OauthCode: 2,
    Payments: 3,
    PaymentRecord: 4,
    SavedPayments: 5,
    OauthClientToken: 6,
    DefaultEntity: 7,
    SuperCorpVatAccounts: 8,
    EntityApprovalRouteLevelUsers: 9,
    EntityApprovalRouteLevelGroups: 10,
    PaymentApprovalRouteLevelGroups: 11,
    OauthApprovals: 12,
    PaymentThirdPartyFees: 13,
    PaymentSourceAccounts: 14,
    EntityApprovalRoutes: 15,
    PaymentCategory: 16,
    SuperCorpCommissionAccounts: 17,
    PaymentAdvise: 18,
    EnumValues: 19,
    Regions: 20,
    States: 21,
    FeeCatParticipants: 22,
    Users: 23,
    Roles: 24,
    UserApprovalGroups: 25,
    FeeCategory: 26,
    OauthClientDetails: 27,
    RolePermission: 28,
    UserWorkHours: 29,
    ApprovalGroups: 30,
    UpdateLog: 31,
    EnumTypes: 32,
    Corporates: 33,
    UserRoles: 34,
    OauthAccessToken: 35,
    PaymentApprovalRoutes: 36,
    PaymentApprovalRouteLevelUsers: 37,
    Issuers: 38,
    GlobalParameters: 39,
    ThirdPartyFeeBeneficiary: 40,
    ReprocessedTranDetails: 41,
    CorporateSourceAccounts: 42,
    ParticipantScale: 43,
    SuperCorporates: 44,
    OauthRefreshToken: 45,
    IssuerHoldingAccounts: 46,
    Permissions: 47,
    PaymentBeneficiaries: 48,
    TransactionDetails: 49,
    paymentStatusUpdate: 50,
    paymentReversal: 51,
    paymentReprocess: 52
};
